package it.neckar.lizergy.comments.lifecycle

import it.neckar.open.kotlin.lang.toCheckboxChar
import kotlinx.serialization.Serializable

/**
 * Lizergy-local copy of the former Commons `LifeCycleState` enum.
 *
 * The Commons enum was renamed to `ArchiveState` in commit 1cf128aefaf (issue #1512) and its
 * archived value was renamed from `EndOfLife` to `Archived`. Lizergy persists `Comment` objects as
 * JSON files that still carry the original property name (`lifeCycleState`) and the original enum
 * value name (`EndOfLife`). This duplicate keeps the former wire format so the service stays
 * compatible with existing storage without a migration.
 */
@Serializable
enum class LifeCycleState {
  Active,
  EndOfLife,

  ;

  fun and(other: LifeCycleState?): LifeCycleState {
    if (other == null) {
      return this
    }

    if (this == EndOfLife || other == EndOfLife) {
      return EndOfLife
    }

    require(this == Active && other == Active) {
      "Unexpected combination this: <$this> other: <$other>"
    }

    return Active
  }

  fun isActive(): Boolean {
    return this == Active
  }

  fun isNotEndOfLife(): Boolean {
    return this != EndOfLife
  }

  fun isEndOfLife(): Boolean {
    return this == EndOfLife
  }

  fun format(): String {
    return when (this) {
      Active -> true.toCheckboxChar()
      EndOfLife -> false.toCheckboxChar()
    }
  }
}
